import { BiBarChartSquare, BiBuildings, BiGroup, BiQuestionMark, BiSpreadsheet, BiVector, FaRegObjectGroup, HiOutlineAdjustments } from "react-icons/all";
import { MdOutlineQuestionAnswer } from 'react-icons/md';

export const MenuConstants = [
  {
    name: "Request",
    item: [
      {
        id: "forms",
        name: "ទម្រង់",
        path: "/form",
        icon: <BiSpreadsheet />,
      },
      {
        id: "questions",
        name: "សំណួរ",
        path: "/question",
        icon: <BiQuestionMark />,
      },
      {
        id: "questions",
        name: "សំនួរត្រៀមខ្លួន",
        path: "/readiness-question",
        icon: <BiBarChartSquare />,
      },
    ],
  },
  {
    name: "Report",
    item: [
      {
        id: "reports",
        name: "របាយការណ៍",
        path: "/report",
        icon: <BiBarChartSquare />,
      },
    ],
  },

  {
    name: "Setting",
    item: [
      {
        id: "reason",
        name: "មូលហេតុ",
        path: "/reason",
        icon: <MdOutlineQuestionAnswer />,
      },
      {
        id: "zones",
        name: "ក្រុមទម្រង់",
        path: "/form-group",
        icon: <FaRegObjectGroup />,
      },
      {
        id: "zones",
        name: "តំបន់",
        path: "/zone",
        icon: <BiVector />,
      },
      {
        id: "companies",
        name: "ក្រុមហ៊ុន",
        path: "/company",
        icon: <BiBuildings />,
      },
      {
        id: "users",
        name: "អ្នកប្រើប្រាស់",
        path: "/user",
        icon: <BiGroup />,
      },

      {
        id: "system-roles",
        name: "ការកំណត់សិទ្ធិអ្នកប្រើប្រាស់",
        path: "/system-role",
        icon: <HiOutlineAdjustments />,
      },
    ],
  },
];
